import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { forEach as _forEach } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'axios';
import { getNameInCurrentLanguage } from 'helpers/intl';

class LeadOrder extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      printing: '',
      message: '',
      tracking: false,
    };
  }

  /* TODO APILink eintragen */
  sendTrackingEmail = orderId => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ printing: 'sendTrackingEmail' }, () => {
      axios.put('/api/...' + orderId + '.json', {}).then(() => {
        this.setState({ printing: '' }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.send_email_tracking}</h1>
                  <p>{messages.sended_email}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      });
    });
  };

  getTrackingInformation = trackingNumber => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ tracking: true }, () => {
      axios
        .get(`/api/ups/${trackingNumber}/tracking.json`)
        .then(({ data }) => {
          this.setState({ tracking: false }, () => {
            const shipments = data?.trackResponse?.shipment ?? [];
            const options = {
              customUI: ({ onClose }) => {
                return (
                  <div className="react-confirm-alert-body">
                    <h1>{messages.tracking_informations}</h1>
                    {shipments.map(shipment => (
                      <div key={'inquiryNumber' + shipment?.inquiryNumber}>
                        <h4>
                          {messages.shipment} {shipment?.inquiryNumber}
                        </h4>
                        {shipment && shipment.package ? (
                          shipment.package.map((pkg, packageIndex) => (
                            <div key={'trackingNumber' + pkg?.trackingNumber}>
                              <h4>{messages.shipment_package + ' ' + packageIndex + 1}</h4>
                              <div>
                                <span>
                                  <strong>{messages.shipment_package_current_status}: </strong>
                                  {pkg?.currentStatus?.simplifiedTextDescription ?? '-'}
                                </span>
                                <br />
                                <span>
                                  <strong>{messages.shipment_package_current_status_description}: </strong>
                                  {pkg?.currentStatus?.description}
                                </span>
                                <br />
                                <span>
                                  <strong>{messages.shipment_package_delivery_date}: </strong>
                                  {this.formatDate(pkg?.deliveryDate?.[0]?.date)} - ({pkg?.deliveryDate?.[0]?.date})
                                </span>
                                <br />
                                <span>
                                  <strong>{messages.shipment_package_delivery_location}: </strong>
                                  {pkg?.deliveryInformation?.location}
                                </span>
                                <br />
                                <span>
                                  <strong>{messages.shipment_package_delivery_receivedBy}: </strong>{' '}
                                  {pkg?.deliveryInformation?.receivedBy}
                                </span>
                              </div>
                            </div>
                          ))
                        ) : shipment && shipment.warnings ? (
                          shipment.warnings.map((warning, warningIndex) => (
                            <div key={warning?.code}>
                              <p>
                                Warning {warningIndex + 1}: {warning.message}
                              </p>
                            </div>
                          ))
                        ) : (
                          <></>
                        )}
                      </div>
                    ))}
                    <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                      <Button
                        style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                        bsStyle="info"
                        onClick={onClose}
                      >
                        OK
                      </Button>
                    </div>
                  </div>
                );
              },
              childrenElement: () => <div />,
              closeOnEscape: true,
              closeOnClickOutside: true,
            };
            confirmAlert(options);
          });
        })
        .catch(error => {
          this.setState({ tracking: false }, () => {
            console.error(error);
            const { doNotify } = this.props;
            doNotify(4, messages.tracking_error);
          });
        });
    });
  };

  formatDate = dateString => {
    const year = dateString?.substring(0, 4);
    const month = dateString?.substring(4, 6);
    const day = dateString?.substring(6, 8);
    const date = new Date(`${year}-${month}-${day}`);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date?.toLocaleDateString('de-DE', options);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    const { printing, tracking } = this.state;

    if (entityLoaded) {
      const detailedOrders = [];
      const trackingLinks = [];
      const upsTrackingButtons = [];

      if (!entity.getOrders() || !(entity.getOrders().length > 0)) {
        detailedOrders.push(
          <div key="orderSelect">
            <FormAutocomplete
              name="order"
              autocompleteType="order"
              label={messages.order}
              disabled={disabled}
              returnValueObject
              onChange={this.updateEntity}
            />
          </div>
        );
      } else {
        _forEach(entity.getOrders(), order => {
          const detailedOrder = [];
          _forEach(order.getItems(), item => {
            if (item.getVendorOrdering()) {
              _forEach(item.getVendorOrdering(), vendorOrdering => {
                _forEach(vendorOrdering.getTrackingNumbers(), trackingNumber => {
                  trackingLinks.push(
                    <div key={trackingNumber}>
                      <ul>
                        <li>
                          {vendorOrdering.getCarrier() === 'UPS' ? (
                            <span>
                              {vendorOrdering.getForeignId() + ' - '}{' '}
                              <a
                                href={'https://www.ups.com/track?loc=de_DE&tracknum=' + trackingNumber}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {trackingNumber}
                              </a>
                              {' (UPS)'}
                            </span>
                          ) : (
                            <span>
                              {vendorOrdering.getForeignId() + ' - '}{' '}
                              <a href={trackingNumber} target="_blank" rel="noopener noreferrer">
                                {trackingNumber}
                              </a>
                              {' (-)'}
                            </span>
                          )}
                        </li>
                      </ul>
                    </div>
                  );
                  upsTrackingButtons.push(
                    <ul>
                      <li>
                        <Button
                          style={{}}
                          bsStyle="success"
                          onClick={() => this.getTrackingInformation(trackingNumber)}
                        >
                          <i className="fas fa-map-marker-alt" />{' '}
                          {messages.ups_tracking_button + ' - ' + trackingNumber}
                        </Button>
                      </li>
                    </ul>
                  );
                });
              });
            }

            const tempVariantAttributes = [];
            if (item.getVariant()) {
              const attributes = item.getVariant().getAttributes();
              if (attributes && attributes.length > 0) {
                _forEach(attributes, attribute => {
                  const attributeNames = attribute.getName();
                  const attributeValues = attribute.getValues();
                  if (attributeNames && attributeValues && attributeNames.length <= attributeValues.length) {
                    _forEach(attributeNames, (attributeName, l) => {
                      const name = attributeName.getName();
                      const values = attributeValues[l].getValue();
                      if (name && values && values.length > 0) {
                        const value = values[0].getName();
                        if (value) {
                          tempVariantAttributes.push(name + ': ' + value);
                        }
                      }
                    });
                  }
                });
              }
            }

            const itemName =
              typeof item.getName() === 'object' ? getNameInCurrentLanguage(item.getName(), appIntl) : item.getName();
            const grossPrice = item?.getGrossPrice().toFixed(2);
            const currency = order?.getPaymentInfo()?.getCurrency();
            const htmlItem = `${Math.min(1, item.getQuantity())} x ${itemName} - ${grossPrice} ${currency}`;
            let htmlDescription = item.getDescription() ? item.getDescription() : '';
            if (tempVariantAttributes.length > 0) {
              htmlDescription += (htmlDescription.length > 0 ? ', ' : '') + tempVariantAttributes.join(', ');
            }
            detailedOrder.push(
              <div key={item.getId()}>
                <ul>
                  <li>
                    <div dangerouslySetInnerHTML={{ __html: htmlItem }} />
                    <div dangerouslySetInnerHTML={{ __html: htmlDescription }} />
                  </li>
                </ul>
              </div>
            );
          });

          detailedOrders.push(
            <div key={order?.getId()}>
              <h4>
                {messages.salesDoc.order}: #{order.getId()}
              </h4>
              <h6>{detailedOrder}</h6>
            </div>
          );
        });
      }

      return (
        <div class="clearfix padding-25 sm-padding-10">
          <Row>
            <Col md={12}>
              <h3>{messages.order}</h3>
            </Col>
          </Row>
          <Row>
            <Col md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">{detailedOrders}</div>
              <a
                href={`${appIntl.urlPrefix}account/items/${entity.getOrders()[0].items[0].item.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-cube" /> {messages.to_the_product}
              </a>
            </Col>
            <Col md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">
                <h4>{messages.selected_shipping_method}</h4>
                <ul>
                  <li>{entity.getOrders()[0].shipping}</li>
                </ul>
              </div>

              <div className="panel panel-transparent">
                <h4>{messages.tracking}</h4>
                <p>{messages.tracking_details}</p>
                {trackingLinks?.length > 0 && trackingLinks}
              </div>
              <div className="panel panel-transparent">
                <h4>{messages.send_tracking_to_customer}</h4>
                <Button
                  style={{ margin: '0 auto', marginTop: '8px', width: '100px' }}
                  bsStyle="primary"
                  onClick={() => this.sendTrackingEmail(entity.getId())}
                >
                  <i
                    className={
                      printing === 'sendTrackingEmail' ? 'far fa-spin fa-spinner-third' : 'fas fa-map-marker-alt'
                    }
                  />{' '}
                  {messages.send}
                </Button>
              </div>
            </Col>
            <Col md={inModal ? 12 : 4}>
              <div className="panel panel-transparent">
                <h4>
                  {messages.ups_tracking_title}{' '}
                  <i className={tracking === true ? 'far fa-spin fa-spinner-third' : ''} />
                </h4>
                {upsTrackingButtons?.length > 0 && upsTrackingButtons}
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return null;
  }
}
LeadOrder.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadOrder)
);
